import Colors, { toRgba } from '@root/gatsby-contentful-core/src/utils/colors';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { Easing } from '@root/gatsby-contentful-core/src/utils/animation';
import { StyleSheet, styled } from '@root/core/src/utils/styles';

const TooltipContent = ({ allMarketSupport, productAvailabilityContent }) => {
  if (!allMarketSupport) { return <p css={styles.loaderText}>State data incoming</p>; }

  return productAvailabilityContent;
};

const MapTooltip = React.forwardRef(({
  allMarketSupport, isMouseOverMap, productAvailabilityContent,
}, ref) => {
  return (
    <Tooltip
      data-testid={'product-availability-map-tooltip'}
      isMouseOverMap={isMouseOverMap}
      ref={ref}
      tabIndex={'-1'}
    >
      <TooltipContent
        allMarketSupport={allMarketSupport}
        productAvailabilityContent={productAvailabilityContent}
      />
    </Tooltip>
  );
});

MapTooltip.propTypes = {
  allMarketSupport: PropTypes.object,
  isMouseOverMap: PropTypes.bool,
  productAvailabilityContent: PropTypes.node,
};

const Tooltip = styled.div({
  display: 'none',
  ...Responsive.md({
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: 'min(220px, 100%)',
    height: 118,
    padding: '14px 22px',
    backgroundColor: Colors.white(),
    border: `1px solid ${Colors.gray20()}`,
    borderRadius: 6,
    boxShadow: `0 18px 30px -10px ${toRgba(Colors.black(), 0.25)}`,
    textAlign: 'left',
    transition: `opacity 200ms ${Easing.easeOutQuart}`,
    pointerEvents: 'none',
    lineHeight: '120%',
  }),
  '&::after': {
    content: '\'\'',
    position: 'absolute',
    bottom: -8,
    left: '50%',
    transform: 'translateX(-50%) rotate(45deg)',
    width: 16,
    height: 16,
    backgroundColor: Colors.white(),
    borderRight: `1px solid ${Colors.gray20()}`,
    borderBottom: `1px solid ${Colors.gray20()}`,
    borderRadius: '50px 0 3px 0',
  },
}, ({ isMouseOverMap }) => {
  return {
    opacity: isMouseOverMap ? 1 : 0,
  };
});

const styles = StyleSheet.create({
  tooltipTitle: {
    color: Colors.nearBlack(),
    marginBottom: 5,
    fontWeight: 600,
    fontSize: 12,
  },
  notAvailableMessage: {
    margin: '0 auto',
    textAlign: 'center',
    maxWidth: 150,
  },
  loaderText: {
    position: 'absolute',
    top: 45,
    left: 30,
    '&:after': {
      overflow: 'hidden',
      display: 'inline-block',
      verticalAlign: 'bottom',
      animation: 'ellipsis steps(4,end) 1800ms infinite',
      content: '"\\2026"', /* ascii code for the ellipsis character */
      width: 0,
    },
    '@keyframes ellipsis': {
      'to': {
        width: '17px',
      },
    },
  },
});

export default MapTooltip;
